module.exports = __webpack_public_path__ + "img/uparrow.a7ddf6d6.svg";